/* jslint browser: true */
/* global require */
/* jscs: disable */
/* jshint ignore:start */

// Glue code which exposes methods to the host and forwards the requests to the
//  backbone application. Switches the host context like "send"ing to the vault
//  context of "receive"ing.
// Expected inbound messages:
//  setHostContext
//  setViewPortInfo
//  navigateTo
//  keyUp
//  logon
//  logout

// console.log('vaultInterface: Loading.');

const BackboneRadio = require('backbone.radio'),
    // _ = require('underscore'),
    _ = require('lodash'),
    configuration = require('./configuration'),
    inChannel = BackboneRadio.channel('vaultInterface:in'),         // vaultInterface translates incoming messages from host to broadcasts on inChannel
    outChannel = BackboneRadio.channel('vaultInterface:out'),       // vaultInterface translates braodcasts on outChannel to messages to host.
    newsChannel = BackboneRadio.channel('vaultInterface:news'); // vaultInterface notifies the newsChannel after events have been handled.


// Glue to have host receive messages from the parent iframe.
const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent",
    messageListener = window[eventMethod],
    messageEvent = (eventMethod == "attachEvent") ? "onmessage" : "message",
    whitelist = /(db101.org$|hb101.org$|eightfoldway.com$)/i;   // allowed message origin domains

var embedded = false,
    iFrameId = '';

//
// Message-receiving side.
//
const validateMessageSource = function (origin) {
        return origin.match(whitelist);
    },
    handleMessageFromParentApplication = function (request, origin) {
        if (!request || !request.sender || request.sender != 'vaultParent')
            return;

        if (!validateMessageSource(origin)) {
            console.warn('vaultInterface: invalid message origin: ' + JSON.stringify(request));
            return;
        }
        // console.log('vaultInterface: receiving message ' + request.command);
        newsChannel.trigger(request.command + '.in.before', request.payload);
        inChannel.trigger(request.command, request.payload);
        newsChannel.trigger(request.command + '.in.after', request.payload);
    };

// Listen to message from parent application, who posts messages to me (this), the child iframe.
messageListener(messageEvent, function (event) {
    var key = event.message ? "message" : "data",
    data = event[key];
    handleMessageFromParentApplication(data, event.origin);
}, false);

//
// Sending side.
//
const parseQueryString = function () {
        var curUri = window.location.toString(),
            q = curUri.lastIndexOf('?'),
            search = (q > 0 ? curUri.substring(q) : ''),
            params = {};
        var a = search.substr(1).split('&');
        for (var i = 0; i < a.length; i++) {
            var b = a[i].split('=');
            params[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
        }
        return params;
    },
    sendCommand = function(commandObject) {     // Send the command to the parent window.
        commandObject.iFrameName = iFrameId;
        // console.log('vaultInterface: sending message ' + commandObject.command);
        parent.postMessage(commandObject, '*');
    },
    attachOutListener = function(cmdName) {
        outChannel.on(cmdName, function(payload) {
            newsChannel.trigger(cmdName + '.out.before', payload);
            sendCommand(_.extend(payload || {}, {command: cmdName}));
            newsChannel.trigger(cmdName + '.out.after', payload);
        });
    },
    init = function() {
        // establish whether we're running embedded in an iFrame.
        if (typeof configuration.embedded === 'undefined') {
            embedded = false;
            iFrameId = '';

            var qs = parseQueryString();
            if (qs && qs.iid) {
                iFrameId = qs.iid;
                embedded = true;
            } else {
                try {
                    if (window.frameElement && window.frameElement !== null) {
                        embedded = true;    // old-style matching domains
                        iFrameId = window.frameElement.id;
                    } else {
                        embedded = window.parent && !!window.parent.id; // throws if cross-origin
                    }
                } catch (error) {
                    embedded = true; // if we get here default to true
                    console.error(error);
                }
            }
            configuration.embedded = embedded;
        }
        configuration.embedded = configuration.embedded === true ? true : false;
    };

// attach listeners for all known messages.
init();
attachOutListener('scrollToTop');   // { offset, ifOutOfFrame }
attachOutListener('vaultDoneLoading');
attachOutListener('requestHostContext');
attachOutListener('requestViewPortInfo');
attachOutListener('expireSession');
attachOutListener('requestLogon');
attachOutListener('hostNavigateTo');    // { target }
attachOutListener('navigateAndPing');   // { target, pingSelector }
attachOutListener('closeDialog');

// last-ditch handler for requestHostContext if not embedded.
outChannel.on('requestHostContext', function(data) {
    if (!configuration.embedded) {
        // console.log('vaultInterface.requestHostContext: Not embedded. Loading default hostContext.');
        inChannel.trigger('setHostContext', configuration.hostContexts[configuration.defaultHostContext] || configuration.hostContexts.guest);
    }
});
